import { isString } from "lodash";
import { ReactNode } from "react";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { CrossIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";
import Loader from "@/shared/ui/Loader";
import TransitionWrapper from "@/shared/widgets/TransitionWrapper";

type Props = {
  header?: ReactNode | string;
  subHeader?: ReactNode;
  footer?: ReactNode;
  withGradient?: boolean;
  children: ReactNode;
  isLoading?: boolean;
  onClose?: () => void;
  scrollRef?: React.RefObject<HTMLDivElement>;
  className?: string;
  isStaticFirst?: boolean;
};
export default function DeviceTabContentWrapper({
  header,
  subHeader,
  children,
  footer,
  withGradient = false,
  isLoading,
  onClose,
  scrollRef,
  className,
  isStaticFirst,
}: Props) {
  const headerComponent = isString(header) ? (
    <div className="pl-1 text-18 text-white font-bold">{header}</div>
  ) : (
    header || <div />
  );

  return (
    <div className={cn("relative flex flex-col size-full grow p-7.5", className)}>
      {isLoading && (
        <div className="absolute z-10 top-0 left-0 size-full bg-dark-900/70">
          <Loader />
        </div>
      )}
      <div className="flex items-center justify-between w-full mb-5">
        {headerComponent}
        <Button className="shrink-0 size-8 p-0" color="gray" variant="soft" onClick={onClose}>
          <CrossIcon className="size-3" />
        </Button>
      </div>
      <TransitionWrapper isStaticFirst={isStaticFirst}>
        {subHeader}
        <div className="relative grow">
          <div
            ref={scrollRef}
            className={clsx(
              "absolute top-0 left-0 bottom-0 overflow-x-clip w-[calc(100%+1.0625rem)] pr-[0.8125rem] overflow-y-auto",
              "[--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]",
              withGradient
                ? "[mask-image:linear-gradient(180deg,black,black,black,transparent)]"
                : "",
            )}
          >
            {children}
          </div>
        </div>
        {footer}
      </TransitionWrapper>
    </div>
  );
}
